import { createAction } from '@reduxjs/toolkit'

export const sendEmailNotification = createAction('email/sendEmailNotification')
